module.exports = __webpack_public_path__ + "img/aniversarios-cuarto-thumbnail.cf923331.jpg";